import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.at.js";
import "core-js/modules/es.string.at-alternative.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { getPvRaApi } from '../api';
import { raAnalysisDownload } from '../store/function/common/raAnalysisDownload';
import { isDateAfterToday } from '@/utils/datetime';

import { mapState, mapActions } from 'vuex';
export default {
  name: 'RaAnalysis',
  data: function data() {
    return {
      loadingData: false,
      searchInput: '',
      // 奇加企業_f108
      selectedDate: '',
      // 'YYYY-MM-DD'
      selectedTimeRange: ['', ''],
      // 'HH:mm:ss'
      selectedDownloadTime: null,
      // 'HH:mm'
      dbRawData: [],
      raData: {},
      isAllExpanded: true,
      downloadInfo: [],
      downloadTimeRange: {
        start: '08:30',
        step: '00:01',
        end: '18:30'
      },
      uploadFile: undefined,
      uploadFileName: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['factoryInfo'])), {}, {
    filteredFactoryInfo: function filteredFactoryInfo() {
      return this.factoryInfo.filter(function (item) {
        return !item.isDemoSite;
      });
    }
  }),
  watch: {
    // 查詢條件一改，清空舊查詢結果與上傳暫存，避免下載到與畫面不符的資料
    searchInput: 'resetResult',
    selectedDate: 'resetResult',
    selectedTimeRange: 'resetResult',
    isAllExpanded: function isAllExpanded() {
      var _this = this;
      Object.values(this.raData).forEach(function (timeItem) {
        if (timeItem.isTimeExpanded !== _this.isAllExpanded) {
          timeItem.isTimeExpanded = _this.isAllExpanded;
        }
        Object.values(timeItem.invObj).forEach(function (invItem) {
          if (invItem.isInvExpanded !== _this.isAllExpanded) {
            invItem.isInvExpanded = _this.isAllExpanded;
          }
        });
      });
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions(['asyncInfo'])), {}, {
    isDateAfterToday: isDateAfterToday,
    resetResult: function resetResult() {
      this.raData = {};
      this.dbRawData = [];
      this.downloadInfo = [];
      this.selectedDownloadTime = null;
      // 清除上傳暫存
      if (this.$refs.inputFile) this.$refs.inputFile.value = null;
      this.uploadFile = undefined;
      this.uploadFileName = '';
    },
    setDownloadTimeRange: function setDownloadTimeRange(dbData) {
      // 查詢的時間 與 api result 的時間不一定一致
      // 需用 api result 的時間 置入 可選擇下載時間，而非用 user 選擇的時間
      var dbDataFirstTime = dbData[0].timestamp.split('T')[1].slice(0, 5);
      var dbDataLastTime = dbData.at(-1).timestamp.split('T')[1].slice(0, 5);
      this.downloadTimeRange.start = dbDataFirstTime;
      this.downloadTimeRange.end = dbDataLastTime;
    },
    search: function search() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var factoryName, fId, timeStart, timeEnd, _yield$getPvRaApi, data, msg;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.searchInput) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", _this2.$swal('請輸入案場'));
              case 2:
                if (_this2.selectedDate) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", _this2.$swal('請選擇日期'));
              case 4:
                if (_this2.selectedTimeRange[0]) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return", _this2.$swal('請選擇時間'));
              case 6:
                factoryName = _this2.searchInput.split('_')[0];
                fId = _this2.searchInput.split('_')[1];
                timeStart = "".concat(_this2.selectedDate, "T").concat(_this2.selectedTimeRange[0], "+08:00");
                timeEnd = "".concat(_this2.selectedDate, "T").concat(_this2.selectedTimeRange[1], "+08:00");
                if (timeStart) {
                  _context.next = 12;
                  break;
                }
                return _context.abrupt("return", _this2.$swal('請選擇時間'));
              case 12:
                if (!(new Date(timeEnd) - new Date(timeStart) > 60 * 60 * 1000)) {
                  _context.next = 14;
                  break;
                }
                return _context.abrupt("return", _this2.$swal.fire({
                  title: '請選擇正確時間區間',
                  text: '查詢範圍一小時(含)以內'
                }));
              case 14:
                _this2.loadingData = true;
                _context.prev = 15;
                _context.next = 18;
                return getPvRaApi(fId, factoryName, timeStart, timeEnd);
              case 18:
                _yield$getPvRaApi = _context.sent;
                data = _yield$getPvRaApi.data;
                _this2.isAllExpanded = true;

                // reset selected time
                _this2.selectedDownloadTime = null;
                if (data.data) {
                  _context.next = 24;
                  break;
                }
                return _context.abrupt("return", _this2.$swal(data.msg || '查詢失敗'));
              case 24:
                // data.success
                _this2.dbRawData = data.data;
                _this2.downloadInfo = [factoryName, _this2.selectedDate];
                _this2.setDownloadTimeRange(data.data);
                _this2.renderData(data.data);
                _context.next = 36;
                break;
              case 30:
                _context.prev = 30;
                _context.t0 = _context["catch"](15);
                // 攔截器對非 2xx 會 reject error.response.data，取其 msg 顯示
                msg = (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.msg) || '';
                if (!(msg.split(' ').pop() === 'provided.')) {
                  _context.next = 35;
                  break;
                }
                return _context.abrupt("return", _this2.$swal.fire({
                  title: '查詢內容有誤',
                  text: '請選擇案場名稱(含編號) 或 時間',
                  footer: "error msg: ".concat(msg)
                }));
              case 35:
                _this2.$swal(msg || '查詢失敗');
              case 36:
                _context.prev = 36;
                _this2.loadingData = false;
                return _context.finish(36);
              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[15, 30, 36, 39]]);
      }))();
    },
    renderData: function renderData(dbData) {
      this.raData = dbData.reduce(function (accu, curr) {
        var timestamp = curr.timestamp.split('T')[1];
        var invNo = curr.invNo;
        var pvNo = curr.pvNo;
        var RA = curr.RA || curr.RA === 0 ? Math.floor(curr.RA * 100) / 100 : '-';
        var IRR = curr.IRR || curr.IRR === 0 ? curr.IRR : '-';
        if (!accu[timestamp]) {
          accu[timestamp] = {
            isTimeExpanded: true,
            invObj: {}
          };
        }
        if (!accu[timestamp].invObj[invNo]) {
          accu[timestamp].invObj[invNo] = {
            isInvExpanded: true,
            raArray: []
          };
        }
        accu[timestamp].invObj[invNo].raArray.push({
          pv: pvNo,
          ra: RA,
          irr: IRR
        });
        return accu;
      }, {});
    },
    download: function download() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var filteredRaData, dataDownload, success, title, text, icon;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.uploadFile) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return", _this3.$swal('請上傳檔案'));
              case 2:
                if (_this3.selectedDownloadTime) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return", _this3.$swal('請選擇下載時間'));
              case 4:
                if (_this3.dbRawData) {
                  _context2.next = 6;
                  break;
                }
                return _context2.abrupt("return", _this3.$swal('請查詢資料再下載'));
              case 6:
                _this3.loadingData = true;
                filteredRaData = _this3.dbRawData.filter(function (obj) {
                  return obj.timestamp.split('T')[1].slice(0, 5) === _this3.selectedDownloadTime;
                });
                _context2.next = 10;
                return raAnalysisDownload.apply(void 0, _toConsumableArray(_this3.downloadInfo).concat([_this3.selectedDownloadTime, filteredRaData, _this3.uploadFile]));
              case 10:
                dataDownload = _context2.sent;
                success = dataDownload.success, title = dataDownload.title, text = dataDownload.text, icon = dataDownload.icon;
                _this3.loadingData = false;
                if (success) {
                  _context2.next = 18;
                  break;
                }
                // reset upload
                _this3.$refs.inputFile.value = null; // 清除 input file value
                _this3.uploadFile = undefined; // 清除要上傳的暫存
                _this3.uploadFileName = '';
                return _context2.abrupt("return", _this3.$swal.fire({
                  title: title,
                  text: text,
                  icon: icon
                }));
              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleChangeFiles: function handleChangeFiles(e) {
      var _this4 = this;
      if (e.target.files.length === 0) {
        this.uploadFile = undefined; // 上傳後又取消，清除要上傳的暫存
        this.uploadFileName = '';
      }
      if (e.target.files.length === 1) {
        var _e$target$files = _slicedToArray(e.target.files, 1),
          file = _e$target$files[0];
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onloadend = function (e) {
          _this4.uploadFile = e.target.result;
          _this4.uploadFileName = file.name;
        };
        reader.onerror = function (err) {
          return console.log(err);
        };
      }
    }
  }),
  mounted: function mounted() {
    var _this5 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (_this5.factoryInfo.length) {
                _context3.next = 3;
                break;
              }
              _context3.next = 3;
              return _this5.asyncInfo();
            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};